import Button from "devextreme-react/button";
import { useContext } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { LoadPagePanel } from "../../../../components";
import { AR, FileTypes } from "../../../../types/enums";
import { showErrorMessage, showSuccessMessage } from "../../../../utils/messages";
import { useSubmitDesign } from "../api/submit-design";
import { RetailOrderContext } from "../context/RetailOrderContext";

export default function SubmitDesignButton() {

	const { order, refetchOrder } = useContext(RetailOrderContext);

	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const returnUrl = encodeURIComponent(searchParams.get("returnUrl") ?? "");

	const submitDesign = useSubmitDesign(
		order.details.retailOrderID,
		(result) => {
			showSuccessMessage("Cabinet Design has been submitted");
			refetchOrder()
				.then(() => {
					if (result.activeARs.includes(120)) {
						const to = `/cfi/retail-order/${order.details.retailOrderID}/120` +
							(!!returnUrl ? '?returnUrl=' + returnUrl : '');

						navigate(to);
					}
				})
		},
		(error) => showErrorMessage(error)
	);

	return (
		<>
			<Button
				elementAttr={{ 'data-testid': 'btn-submit-design' }}
				text={"Submit Design"}
				icon="Inscyth-Confirm"
				visible={order.details.activeARs.includes(AR.DealerToSubmitCabinetDesign)}
				disabled={submitDesign.isLoading}
				onClick={() => {
					if (!order.details.files.find(x => x.fileTypeID === FileTypes.CabinetDesignPacket)) {
						showErrorMessage('Cabinet Design Packet file is required');
					}
					else {
						submitDesign.mutate();
					}
				}} >
			</Button>
			<LoadPagePanel visible={submitDesign.isLoading}></LoadPagePanel>
		</>
	)
}
